import AOS from "aos";
import "aos/dist/aos.css";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";
import React, { useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import { useTranslation } from "react-i18next";
import emailjs from "emailjs-com";
import "./style.css";
import { API_BASE_URL } from "../../config/config";

function ContactUs() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });
  const [alertMessage, setAlertMessage] = useState("");
  const [topics, setTopics] = useState([]);
  const { t, i18n } = useTranslation();

  const languageMap = { tj: 1, ru: 2, en: 3 };
  const getLanguageCode = (lang) => languageMap[lang] || 2;

  const fetchTopics = async (langCode) => {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/api/topics?lang=${langCode}`,
        {
          headers: {
            accept: "text/plain",
            "api-version": "1.0",
          },
        },
      );
      setTopics(response.data);
    } catch (error) {
      console.error("Error fetching topics:", error);
    }
  };

  useEffect(() => {
    const langCode = getLanguageCode(i18n.language);
    fetchTopics(langCode);
    AOS.init({ duration: 2000 });
  }, [i18n.language]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.id]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (
      !formData.name ||
      !formData.email ||
      !formData.message ||
      !formData.subject
    ) {
      setAlertMessage("Please fill in all required fields.");
      setTimeout(() => setAlertMessage(""), 3000);
      return;
    }

    const data = {
      userName: formData.name,
      email: formData.email,
      topicId: formData.subject,
      topicName: topics.find((topic) => topic.id === Number(formData.subject))
        ?.name,
      message: formData.message,
      time: new Date().toLocaleString(),
      lang: getLanguageCode(i18n.language),
    };

    try {
      const response = await axios.post(`${API_BASE_URL}/api/feedBacks`, data, {
        headers: {
          accept: "text/plain",
          "Content-Type": "application/json",
          "api-version": "1.0",
        },
      });

      if (response.data.code === 1) {
        setAlertMessage(t("Successfully sent!"));
        setFormData({ name: "", email: "", subject: "", message: "" });
        setTimeout(() => setAlertMessage(""), 3000);
      } else {
        setAlertMessage("Failed to send to API.");
      }
    } catch (err) {
      console.error(
        "Swagger API error:",
        err.response ? err.response.data : err.message,
      );
      setAlertMessage("Failed to send to API.");
      setTimeout(() => setAlertMessage(""), 3000);
    }

    const emailTemplateParams = {
      userName: data.userName,
      email: data.email,
      topicName: data.topicName,
      message: data.message,
      time: data.time,
    };

    try {
      await emailjs.send(
        "service_p5sjp16",
        "template_ms3ldbd",
        emailTemplateParams,
        "4AdyB8Kv126nbR9ek",
      );
      console.log("Email sent successfully!");
    } catch (err) {
      console.error("EmailJS error:", err);
    }
  };

  return (
    <Container fluid className="gradient-div p-5 positionRel">
      <Row className="justify-content-md-center">
        <h2 className="fontWhite mb-4 text-center">{t("Contact us")}</h2>
        {alertMessage && (
          <div className="alert alert-success">{alertMessage}</div>
        )}
        <Col sm lg="8" className="formBackgroun rounded p-3 zIndex">
          <Form onSubmit={handleSubmit}>
            <Row className="justify-content-md-center">
              <Col sm lg="6" className="formBackgroun rounded p-3">
                <h6 className="text-start">{t("name")}</h6>
                <Form.Control
                  className="mb-3"
                  size="lg"
                  type="text"
                  id="name"
                  placeholder={t("Enter your name")}
                  value={formData.name}
                  onChange={handleChange}
                />
                <h6 className="text-start">
                  {t("email")} <span style={{ color: "red" }}>*</span>
                </h6>
                <Form.Control
                  className="mb-3"
                  size="lg"
                  type="email"
                  id="email"
                  placeholder={t("Enter your email")}
                  value={formData.email}
                  onChange={handleChange}
                />
                <h6 className="text-start">{t("type messeg")}</h6>
                <Form.Control
                  className="mb-3"
                  size="lg"
                  as="select"
                  id="subject"
                  value={formData.subject}
                  onChange={handleChange}
                >
                  <option value="">{t("type messeg select")}</option>
                  {topics.map((topic) => (
                    <option key={topic.id} value={topic.id}>
                      {topic.name}
                    </option>
                  ))}
                </Form.Control>
              </Col>
              <Col sm lg="6" className="formBackgroun rounded p-3">
                <h6 className="text-start">{t("messeg")}</h6>
                <Form.Control
                  className="mb-3"
                  size="lg"
                  as="textarea"
                  id="message"
                  placeholder={t("Enter your messeg")}
                  value={formData.message}
                  onChange={handleChange}
                  style={{ height: "167px" }}
                />
                <Button type="submit" size="lg" className="w-100 buttonColor">
                  {t("Send")}
                </Button>
              </Col>
            </Row>
          </Form>
        </Col>
      </Row>
    </Container>
  );
}

export default ContactUs;
